// @flow
import xws from 'api/xws/';
import qs from 'query-string';
import type { AxiosPromise } from 'axios';

// Constants
import { getService } from 'constants/ajax';

type RequestData = {|
  tokenId: string,
  webkey: string,
  locale: string,
  countryCodeParam: string
|};

type State = {
  code: string,
  name: string
};

type StatesResponse = {
  key: string,
  states?: Array<State>,
  statusCode: number,
  successs: boolean
};

export default function updateStateAddressWs({
  tokenId,
  webkey,
  locale,
  countryCodeParam: countryCode
}: RequestData): AxiosPromise<RequestData, StatesResponse> {
  const statesService = getService('states');
  statesService.setPathVars({ countryCode });
  return xws(statesService).post(
    statesService.getPath(),
    qs.stringify({
      tokenId,
      webkey,
      locale
    })
  );
}



// WEBPACK FOOTER //
// ./src/api/xws/profile/stateAddressWs.js